import { useHttp } from '../http'

export const useAdviceSectionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`advice-sections/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`advice-sections`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`advice-sections/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`advice-sections`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`advice-sections/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
